import React from 'react';
import Icon from '../../../components/AppIcon';

const CharacterListItem = ({ character, isActive, onClick }) => {
  const classIcons = {
    'Warrior': 'Sword',
    'Cleric': 'Heart',
    'Rogue': 'Zap',
    'Wizard': 'Sparkles',
    'Ranger': 'Target',
    'Paladin': 'Shield',
    'Necromancer': 'Skull',
    'Enchanter': 'Wand2',
    'Magician': 'Flame',
    'Bard': 'Music',
    'Monk': 'Hand',
    'Druid': 'Leaf',
    'Shaman': 'Wind',
    'Berserker': 'Axe',
    'Beastlord': 'Paw'
  };

  return (
    <button
      onClick={onClick}
      className={`w-full p-4 md:p-5 lg:p-6 rounded-xl text-left transition-all duration-250 ease-out ${
        isActive 
          ? 'bg-primary text-primary-foreground shadow-warm-md' 
          : 'bg-card hover:bg-muted hover:shadow-warm-sm'
      }`}
    >
      <div className="flex items-center gap-3 md:gap-4">
        <div className={`w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 rounded-lg flex items-center justify-center ${
          isActive ? 'bg-primary-foreground/20' : 'bg-accent'
        }`}>
          <Icon 
            name={classIcons?.[character?.class] || 'User'} 
            size={20}
            color={isActive ? 'var(--color-primary-foreground)' : 'var(--color-accent-foreground)'}
          />
        </div>
        
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="text-base md:text-lg font-semibold truncate">
              {character?.name}
            </h3>
            {character?.isMain && (
              <span className={`px-2 py-0.5 rounded text-xs font-medium ${
                isActive ? 'bg-primary-foreground/20' : 'bg-accent/20'
              }`}>
                Main
              </span>
            )}
          </div>
          <p className={`text-xs md:text-sm ${isActive ? 'opacity-90' : 'text-muted-foreground'}`}>
            Level {character?.level} {character?.class}
          </p>
          
          <div className="mt-2 md:mt-3">
            <div className="flex items-center justify-between mb-1">
              <span className={`text-xs ${isActive ? 'opacity-80' : 'text-muted-foreground'}`}>
                Progression
              </span>
              <span className={`text-xs font-medium ${isActive ? 'opacity-90' : ''}`}>
                {character?.progression}%
              </span>
            </div>
            <div className={`w-full h-1.5 md:h-2 rounded-full overflow-hidden ${
              isActive ? 'bg-primary-foreground/20' : 'bg-muted'
            }`}>
              <div 
                className={`h-full transition-all duration-500 ${
                  isActive ? 'bg-primary-foreground' : 'bg-success'
                }`}
                style={{ width: `${character?.progression}%` }}
              />
            </div>
          </div>
        </div>

        {isActive && (
          <Icon name="Check" size={20} color="var(--color-primary-foreground)" />
        )}
      </div>
    </button>
  );
};

export default CharacterListItem;